function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { values } from 'ramda';
import { ApiConstants, ThunkHelper } from 'invision-core';
export var RETRIEVE_CANDIDATE_BILL_CYCLES = {
  BEGIN: 'RETRIEVE_CANDIDATE_BILL_CYCLES_BEGIN',
  SUCCESS: 'RETRIEVE_CANDIDATE_BILL_CYCLES_SUCCESS',
  FAILURE: 'RETRIEVE_CANDIDATE_BILL_CYCLES_FAILURE'
};
var retrieveCandidateBillCyclesPromise = function retrieveCandidateBillCyclesPromise(dispatch, customerId, orderType) {
  return ThunkHelper(dispatch, values(RETRIEVE_CANDIDATE_BILL_CYCLES), {
    method: 'post',
    url: 'SubscriberManagement/EvaluateBillCycleRules',
    data: {
      OrderType: orderType
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveCandidateBillCycles = function retrieveCandidateBillCycles(customerId, orderType) {
  return function (dispatch) {
    return retrieveCandidateBillCyclesPromise(dispatch, customerId, orderType);
  };
};
export var RETRIEVE_BILL_CYCLE_DETAILS = {
  BEGIN: 'RETRIEVE_BILL_CYCLE_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_BILL_CYCLE_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_BILL_CYCLE_DETAILS_FAILURE'
};
var retrieveBillCycleDetailsPromise = function retrieveBillCycleDetailsPromise(dispatch, billCycleId) {
  return ThunkHelper(dispatch, values(RETRIEVE_BILL_CYCLE_DETAILS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerBillCycleDetailsById',
    data: {
      Id: billCycleId
    }
  });
};
export var retrieveBillCycleDetails = function retrieveBillCycleDetails(billCycleId) {
  return function (dispatch) {
    return retrieveBillCycleDetailsPromise(dispatch, billCycleId);
  };
};
export var RETRIEVE_NEXT_BILL_CYCLE_DETAILS = {
  BEGIN: 'RETRIEVE_NEXT_BILL_CYCLE_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_NEXT_BILL_CYCLE_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_NEXT_BILL_CYCLE_DETAILS_FAILURE'
};
var retrieveNextBillCycleDetailsPromise = function retrieveNextBillCycleDetailsPromise(dispatch, billCycleId) {
  return ThunkHelper(dispatch, values(RETRIEVE_NEXT_BILL_CYCLE_DETAILS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerBillCycleDetailsById',
    data: {
      Id: billCycleId
    }
  });
};
export var retrieveNextBillCycleDetails = function retrieveNextBillCycleDetails(billCycleId) {
  return function (dispatch) {
    return retrieveNextBillCycleDetailsPromise(dispatch, billCycleId);
  };
};